import { render, staticRenderFns } from "./PurchaseStatusSelect.vue?vue&type=template&id=12c40b27&"
import script from "./PurchaseStatusSelect.vue?vue&type=script&lang=js&"
export * from "./PurchaseStatusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports